<template>
    <div v-if="!collapsed" ref="root" class="nl-ad" :class="['nl-ad--' + size]">
        <p class="mb-1.5 text-center text-[0.625rem] uppercase tracking-wider text-nomad-500" :class="{ invisible: empty }">Advertisement</p>
        <div class="nl-ad__box mx-auto overflow-hidden rounded-md" :class="{ 'bg-white/[0.02]': !empty }">
            <ins v-if="active" ref="ins" class="adsbygoogle nl-ad__ins" :data-ad-client="client" :data-ad-slot="slotId"
                :data-adtest="adTest ? 'on' : null"></ins>
        </div>
    </div>
</template>
<script>
import { ADSENSE_CLIENT, AD_SLOTS } from "@/config/ads";

// Sizes are fixed per breakpoint (see app.css) so the page never shifts when an ad loads.
export default {
    name: "AdSlot",
    props: {
        // Key from AD_SLOTS
        placement: { type: String, required: true },
        // banner: 320x100 on phones, 728x90 from md up; rectangle: 300x250
        size: { type: String, default: "banner" },
    },
    data() {
        return {
            client: ADSENSE_CLIENT,
            active: false,
            collapsed: false,
            empty: false,
            adTest: false,
        };
    },
    computed: {
        slotId() {
            return AD_SLOTS[this.placement] || AD_SLOTS.listFeed;
        },
    },
    mounted() {
        const host = window.location.hostname;
        this.adTest = host === "localhost" || host === "127.0.0.1" || host.endsWith(".test");

        // Request the ad only when the slot is close to the viewport.
        // Slots hidden with display:none (e.g. desktop-only) never intersect, so they never load.
        if (!("IntersectionObserver" in window)) {
            this.load();
            return;
        }
        this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                this.observer.disconnect();
                this.load();
            }
        }, { rootMargin: "300px 0px" });
        this.observer.observe(this.$refs.root);
    },
    beforeUnmount() {
        this.observer?.disconnect();
        this.statusObserver?.disconnect();
    },
    methods: {
        load() {
            // The <ins> is only added now: adsbygoogle.push() fills the first unprocessed <ins>
            // in the document, so rendering them lazily keeps each push matched to its own slot.
            this.active = true;
            this.$nextTick(() => {
                const ins = this.$refs.ins;
                if (!ins) return;
                this.statusObserver = new MutationObserver(() => {
                    if (ins.getAttribute("data-ad-status") === "unfilled") this.onUnfilled();
                });
                this.statusObserver.observe(ins, { attributes: true, attributeFilter: ["data-ad-status"] });
                try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                } catch (error) {
                    this.onUnfilled();
                }
            });
        },
        onUnfilled() {
            // Removing a slot the reader can already see (or has scrolled past) moves the page,
            // so only collapse it while it is still below the screen; otherwise leave blank space.
            const rect = this.$refs.root?.getBoundingClientRect();
            if (rect && rect.top > window.innerHeight) this.collapsed = true;
            else this.empty = true;
        },
    },
};
</script>
